import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

import { Eventos, EventService } from '../shared';
import { EntityService, ModalService, ToastService } from '../../core';

@Component({
  moduleId: module.id,
  selector: 'bp-event',
  templateUrl: 'event.component.html'
})

export class EventComponent implements OnInit, OnDestroy {
  @Input() event: Eventos;
  editEvent: Eventos = <Eventos>{};
  date7: Date = new Date();

  private dbResetSubscription: Subscription;
  private id: any;

  constructor(
    private entityService: EntityService,
    private modalService: ModalService,
    private route: ActivatedRoute,
    private router: Router,
    private eventService: EventService,
    private toastService: ToastService
  ) { }
  ngOnInit(): void {

    // this.dbResetSubscription = this.eventService.onDbReset
    //   .subscribe(() => this.getEvent());

    this.route
      .params
      .map(params => params['id'])
      .do(id => this.id = +id)
      .subscribe(id => {
        // console.log('samo probam', id);
        this.getEvent();
      });
  }

  ngOnDestroy(): void {
   // this.dbResetSubscription.unsubscribe();
  }
  cancel(showToast = true) {
    this.editEvent = this.entityService.clone(this.event);
    if (showToast) {
      this.toastService.activate(`Cancelled changes to ${this.event.title}`);
    }
  }

  

  delete() {
    let msg = `Do you want to delete ${this.event.title}?`;
    this.modalService.activate(msg).then(responseOK => {
      if (responseOK) {
        this.cancel(false);
        this.eventService.deleteEvent(this.event)
          .subscribe(() => {
            this.toastService.activate(`Deleted ${this.event.title}`);
            this.gotoEvents();
          },
          (err) => this.handleServiceError('Delete', err), // Failure path
          () => console.log('Delete Completed') // Completed actions
          );
      }
    });
  }

  isAddMode() {
    return isNaN(this.id);
  }

  private getEvent() {
    if (this.id === 0) { return; };
    if (this.isAddMode()) {
      this.event = <Eventos>{ id: null, start: null, end: null, allDay: false, title: '', url: '' };
      this.editEvent = this.entityService.clone(this.event);
      return;
    }
    this.eventService.getEventt(this.id)
      .subscribe(event => this.setEditEvent(event));
  }

  private gotoEvents() {
    this.router.navigate(['/events']);
  }

  private handleServiceError(op: string, err: any) {
    console.error(`${op} error: ${err.message || err}`);
  }

  private isDirty() {
    return this.entityService.propertiesDiffer(this.event, this.editEvent);
  }

  private setEditEvent(event: Eventos) {
    if (event) {
      this.event = event;
      this.editEvent = this.entityService.clone(this.event);
    } else {
      this.gotoEvents();
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/events/event/event.component.ts